import '@babel/polyfill';
import Vue from 'vue';
import App from './App.vue';
import store from '@/store';
import VueRouter from 'vue-router';
import router from './router';
import BootstrapVue, { BIcon } from 'bootstrap-vue';
import 'bootstrap-icons/font/bootstrap-icons.css';
import cssVars from 'css-vars-ponyfill';
import * as Sentry from '@sentry/vue';

import '@/assets/custom.scss';
import '@/assets/fonts.css';
import '@/assets/basic.css';
import '@/assets/print.css';
import '@/assets/btn_badge.css';
import '@/assets/forms.css';
import '@/assets/modal_toasts.css';
import '@/assets/line_border_table.css';
import '@/assets/no_line_border_table.css';
import '@/assets/custom.css';
import '@/assets/skinc.css';
import MD from '@/components/global_components/MD';
import MdSb from '@/components/global_components/MdSb.vue';
import TodoRoadmap from '@/components/global_components/TodoRoadmap';
import BackToTop from '@/components/global_components/BackToTop';
import NeedHelp from '@/components/global_components/NeedHelp';
import CustomVueEditor from '@/components/writing_report/util/CustomVueEditor.vue';
import CustomColorPicker from '@/components/writing_report/util/CustomColorPicker.vue';
import '@/plugins/start';
import checkView from 'vue-check-view';
import VueObserveVisibility from 'vue-observe-visibility';

Vue.component('Md', MD);
Vue.component('Mdsb', MdSb);
Vue.component('TodoRoadmap', TodoRoadmap);
Vue.component('BackToTop', BackToTop);
Vue.component('NeedHelp', NeedHelp);
Vue.component('VEditor', CustomVueEditor);
Vue.component('ColorPicker', CustomColorPicker);
Vue.component('BIcon', BIcon);

Vue.config.productionTip = false;

Vue.use(VueRouter);
Vue.use(BootstrapVue);
Vue.use(checkView);
Vue.use(VueObserveVisibility);

Vue.prototype.$EventBus = new Vue();

cssVars({
  rootElement: document,
  shadowDOM: false,

  include: 'link[rel=stylesheet], style',
  exclude: '',
  variables: {
    '--fa': '1',
    '--fa-animation-timing': 'ease',
    '--fa-animation-direction': 'normal',
    '--fa-animation-duration': '1s',
    '--fa-animation-iteration-count': 'infinite',
    '--fa-beat-scale': '1.2',
    '--fa-bounce-start-scale-x': '1',
    '--fa-bounce-start-scale-y': '1',
    '--fa-bounce-jump-scale-x': '1.2',
    '--fa-bounce-jump-scale-y': '1.2',
    '--fa-bounce-height': '10px',
    '--fa-bounce-land-scale-x': '1',
    '--fa-bounce-land-scale-y': '1',
    '--fa-bounce-rebound': '0.5',
    '--fa-fade-opacity': '0.5',
    '--fa-beat-fade-opacity': '0.5',
    '--fa-beat-fade-scale': '1.1',
    '--fa-flip-x': '0',
    '--fa-flip-y': '0',
    '--fa-flip-z': '0',
    '--fa-flip-angle': '0deg',
    '--fa-rotate-angle': '0deg',
    '--fa-stack-z-index': '1',
    '--fa-inverse': '0',
    '--fa-style-family': 'solid',
    '--fa-style': 'normal',
    '--fa-display': 'inline-block',
    '--fa-li-margin': '0.5em',
    '--fa-li-width': '2em',
    '--fa-border-color': '#000000',
    '--fa-border-radius': '0.2em',
    '--fa-border-style': 'solid',
    '--fa-border-width': '1px',
    '--fa-border-padding': '0.2em',
    '--fa-pull-margin': '0.3em',
    '--fa-animation-delay': '0s'
  },

  onlyLegacy: true,
  preserveStatic: true,
  preserveVars: false,
  silent: false,
  updateDOM: true,
  updateURLs: true,
  watch: false
});

Sentry.init({
  Vue,
  dsn: process.env.VUE_APP_SENTRY_DSN,
  environment: process.env.VUE_APP_SENTRY_ENV_TAG,
  debug: process.env.VUE_APP_SENTRY_ENV_TAG === 'report-test',
  integrations: [
    // Sentry.replayIntegration(),
    Sentry.browserTracingIntegration({ router, routeLabel: 'path' }),
    Sentry.vueIntegration({
      tracingOptions: {
        trackComponents: true,
        timeout: 500 // milliseconds
      }
    })
  ],
  tracesSampleRate: 0.8, // default 는 1이나 너무 민감하므로 실제는 0.6 정도로 낮춥니다.
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

Vue.prototype.$Sentry = Sentry;

const vue_instance = new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app');

export { vue_instance };
